import { IScopeRuleUIFormat } from './ScopeRuleUIFormat';

export const enum FILTER_NAMES {
	URLS = 'urls',
	ISSUE_TYPES = 'issueTypes',
	ISSUE_SEVERITIES = 'issueSeverities'
}

export interface IFilter {
	name: FILTER_NAMES;
	included: boolean;
	value: string[];
}

interface IConfigurationObj {
	filters: IFilter[];
}

export interface IPropertyView {
	id: string;
	name: string;
	propertyId: string;
	configuration: IConfigurationObj;
	updatedTime?: string;
}

// searchStr includes view name and updated date for table filtering purpose
export interface IPropertyViewRow extends IPropertyView {
	searchStr: string;
}

export interface INewView {
	name: string;
	propertyId: string;
	configuration: IConfigurationObj;
}

export interface IViewState {
	id?: string; // optional as exists only in "Edit"
	name: string;
	propertyId: string;
	rulesList: IScopeRuleUIFormat[];
}

export interface ISelectedViewResponse {
	id: string;
	propertyId: string;
	viewId?: string;
}
